import angular from 'angular';

import './page-not-found.styles.scss';

import Routes from './page-not-found.routes';

export default angular.module('autoboard.404', [])
  .config(Routes)
  .name;
